// removed by extract-text-webpack-plugin
module.exports = {"readyToBuild":"readyToBuild--2ac5W","readyToBuildButton":"readyToBuildButton--3R8Bp"};